import React from 'react';
import { Paper, Button, IconButton, Select, MenuItem, InputLabel, FormControl } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import './SCUISelectFieldWithButton.scss';
export const SCUISelectFieldWithButton = (props: any) => {
    let selectText = props.selectText ? props.selectText : 'text';
    let selectId = props.selectId ? props.selectId : 'value';

    return (
        <Paper className="textFieldWithButtonPaper buttonSelectField">
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{props.selectPlaceHolder} </InputLabel>
                <Select
                    style={{ height: 38 }}
                    defaultValue={1}
                    label={props.selectPlaceHolder}
                    value={props.selectValue}
                    onChange={props.onChangeSelect}
                    sx={{
                        boxShadow: 'none',
                        verticalAlign: 'middle',
                        '.MuiOutlinedInput-notchedOutline': {
                            border: 0,
                            borderRight: 1,
                            borderColor: '#e0e0e0',
                            borderRadius: 0,
                        },
                    }}
                >
                    {props.selectList &&
                        props.selectList.map((selecListItem: any) => (
                            <MenuItem value={selecListItem[selectId]} key={selecListItem[selectId]}>
                                {selecListItem[selectText]}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>

            {props.buttonText ? (
                <Button color="primary" type="button" onClick={props.onClickButton} className={'textFieldWithButton'}>
                    {props.buttonText}
                </Button>
            ) : (
                <IconButton color="primary" className="svg_icons" type="button" onClick={props.onClickButton}>
                    <SearchIcon />
                </IconButton>
            )}
        </Paper>
    );
};
